import { DefaultService } from '@/services/DefaultService';


export default class AssMotivoAtendimentoFormFormularioService extends DefaultService {

    findAll(column, order, page, limit, situacao, idMotivoAtendimento, geralTabela = '', ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/assformformulariogeraltabela.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idTabelaFrom=${idMotivoAtendimento}&geralTabela=${geralTabela}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    find(id, contexto = "pro") {
        return this._http.get(`${this._env}/${contexto}/assformformulariogeraltabela/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    findRespondidoByUuid(uuid, contexto = "ven") {
        return this._http.get(`${this._env}/${contexto}/formRespostaCabecalho/${uuid}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(assMotivoAtendimentoFormulario) {
        return this._http.post(`${this._env}/ven/assformformulariogeraltabela/updatesituacao`, assMotivoAtendimentoFormulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findFormulariosNaoAssociados(column, order, page, limit, idMotivoAtendimento, geralTabela = '', contexto='', ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/assformformulariogeraltabela/formulariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idTabelaFrom=${idMotivoAtendimento}&geralTabela=${geralTabela}&contexto=${contexto}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(assMotivoAtendimentoFormulario) {
        return this._http.post(`${this._env}/ven/assformformulariogeraltabela`, assMotivoAtendimentoFormulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    updateObrigatorio(assMotivoAtendimentoFormulario) {
        console.log(assMotivoAtendimentoFormulario);
        return this._http.post(`${this._env}/ven/assformformulariogeraltabela/updateobrigatorio`, assMotivoAtendimentoFormulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    findAssFormGeral(idTabelaFrom, geralTabela) {
        return this._http.get(`${this._env}/ven/formPreenchimento/assformformulariogeraltabela.json?idTabelaFrom=${idTabelaFrom}&geralTabela=${geralTabela}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}